import { render, staticRenderFns } from "./ModeratedOperationState.vue?vue&type=template&id=2c60c972&scoped=true"
import script from "./ModeratedOperationState.vue?vue&type=script&lang=js"
export * from "./ModeratedOperationState.vue?vue&type=script&lang=js"
import style0 from "./ModeratedOperationState.vue?vue&type=style&index=0&id=2c60c972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c60c972",
  null
  
)

export default component.exports